import { render, staticRenderFns } from "./account-form.vue?vue&type=template&id=4da1198c&scoped=true&"
import script from "./account-form.vue?vue&type=script&lang=js&"
export * from "./account-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1198c",
  null
  
)

export default component.exports